import { Pipe, PipeTransform } from '@angular/core';

/**
 * Use in template:
 * filterObjectsByProperties: ['properties'] : searchTerm"
*/

@Pipe({
    name: 'filterObjectsByProperties'
})
export class FilterObjectsByPropertiesPipe implements PipeTransform {
    transform(items: any[], fields: string[], searchTerm: string): any[] {
        if (searchTerm) {
            // filter array of objects
            return items.filter(item => {
                // returns array of objects property names
                return Object.keys(item)
                    // checks if any item in an array passes the condition
                    .some(prop => {
                        // loop given properties
                        for (const field of fields) {
                            // check if the object properties match the given properties
                            if (item[prop] === item[field]) {
                                // check property is not null
                                if (item[prop] !== null) {
                                    // return true if property value match the searchTerm
                                    return item[prop].toLowerCase().includes(searchTerm.toLowerCase());
                                }
                            }
                        }
                    });
            });
        }
        return items;
    }
}
